import { i18n } from '../../localization';

const state = {
    showConfirm: false,
    resolveHandler: null,
    rejectHandler: null,
    confirmTitle: '',
    confirmBody: '',
    confirmOk: '',
    confirmCancel: '',
    styleClass: null,
};

const mutations = {
    SET_CONFIRMATION_DATA(state, { confirmTitle, confirmBody, confirmOk, confirmCancel, styleClass }) {
        state.confirmBody = confirmBody;
        state.confirmTitle = confirmTitle;
        state.confirmOk = confirmOk;
        state.confirmCancel = confirmCancel;
        state.styleClass = styleClass;
        state.showConfirm = true;
    },
    OK_CONFIRM: state => {
        state.showConfirm = false;
        state.resolveHandler(true);
    },
    CANCEL_CONFIRM: state => {
        state.showConfirm = false;
        if (typeof state.resolveHandler === 'function') {
            state.resolveHandler(false);
        }
    },
    HIDE_CONFIRM: state => {
        state.showConfirm = false;
    },
};

const actions = {
    /**
     * Init confirmation dialog
     * @param {object} state
     * @param {object} commit
     * @param {string} confirmTitle - confirmation title
     * @param {string} confirmBody - confirmation body
     * @param {string} confirmOk - text for confirmation 'ok' button
     * @param {string} confirmCancel - text for confirmation 'cancel' button
     * @returns {Promise}
     */
    confirmation(
        { state, commit },
        {
            confirmTitle = i18n.t('common.confirmDialog'),
            confirmBody = i18n.t('common.confirm'),
            confirmOk = i18n.t('common.ok'),
            confirmCancel = i18n.t('common.cancel'),
            styleClass = '',
        }
    ) {
        commit('SET_CONFIRMATION_DATA', { confirmTitle, confirmBody, confirmOk, confirmCancel, styleClass });
        return new Promise((resolve, reject) => {
            state.resolveHandler = resolve;
            state.rejectHandler = reject;
        });
    },
    /**
     * Init success action and close confirmation dialog
     * @param commit
     */
    ok({ commit }) {
        commit('OK_CONFIRM');
    },

    /**
     * Init cancel action and close confirmation dialog
     * @param {object} commit
     */
    cancel({ commit }) {
        commit('CANCEL_CONFIRM');
    },

    /**
     * Just hide the confirmation dialog
     * @param {object} commit
     */
    hide({ commit }) {
        commit('HIDE_CONFIRM');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
